/* istanbul ignore file -- barrel export only */
import BorderBeam from './BorderBeam';
export default BorderBeam;
